/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $, SCS, debug) {
	'use strict';

	/**
	 * Responsive Footer
	 *
	 * @author Cesar Keller
	 * @namespace Tc.Module
	 * @class Footer
	 * @extends Tc.Module
	 */
	Tc.Module.Footer = Tc.Module.extend({

		on: function (callback) {
			var mod = this,
				$ctx = mod.$ctx;

			mod.lessVars = SCS.utils.getLessVars($ctx) || { mobile: { breakpoint: 768 } };

			if (!$('body.is-mobile').length) {
				// only init the responsive parts if we're not in NEVIS forced mobile mode -> there the desktop clientlib is missing and some of the new headers parts relies on it
				mod.initResponsiveness();
			} else {
				$ctx.addClass('scsh-mobile');
				debug.log('Tc.Module.Footer > forced mobile mode (non-responsive)');
			}

			mod.initLanguageSwitch();

			callback();
		},

		initLanguageSwitch: function () {
			var mod = this,
				$links = mod.$ctx.find('.scs-footer-lang-switch a');

			if (!$links.length) {
				return;
			}
			function updateLinks() {
				$links.each(function () {
					this.hash = location.hash;
					mod.log('updated hash', this.href);
				});
			}
			$(window).on('hashchange', updateLinks);
			updateLinks();
		},

		initResponsiveness: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$window = $(window);

			function checkWidth() {
				if (!mod.lessVars.mobile) {
					debug.error('lessVars.mobile is missing!', mod.lessVars);
					mod.lessVars.mobile = { breakpoint: 768 };
				}
				var isMobile = $window.width() <= Number(mod.lessVars.mobile.breakpoint);

				$ctx.toggleClass('scsh-mobile', isMobile);
				$ctx.toggleClass('scsh-desktop', !isMobile);
				debug.log('Tc.Module.Footer > initResponsiveness', $ctx.attr('class'), isMobile ? 'isMobile' : 'isDesktop');
			}
			$window.on('load resize', checkWidth);
			checkWidth();
		}
	});
}(window.Tc, window.Tc.$, window.SCS, window.debug));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Footer.js
// module id = 361
// module chunks = 0